/**
 * 阿里云人机校验
 */
/*eslint-disable*/
import globalConfig from '@/lib/http/global-config'

/* eslint-disable camelcase, no-script-url */
const isH5 = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

let initSuccess = false

const appkey = process.env.VUE_APP_BOT_APP_KEY

// const appkey = 'FFFF0N3N0000000008C8' // 全部用生产环境

function initCfg() {
  window.NVC_Opt = {
    // 无痕配置 && 滑动验证、刮刮卡验证码通用配置。
    // 应用类型标识。它和使用场景标识（scene字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
    appkey,

    // 使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
    scene: isH5 ? 'nvc_login' : 'nvc_login_h5',

    // 是否HTML5页面。对于PC端Web页面类型，该参数值需填写false。
    isH5,

    // 二次验证的唤醒方式。true为浮层式，false为嵌入式。
    popUp: false,

    // 声明二次验证需要渲染的目标元素ID。
    renderTo: '#captcha',

    // 回调参数。
    nvcCallback(data) {
      // 其中，data为getNVCVal()函数的值，该函数为二次验证滑动或者刮刮卡通过后的回调函数。
      // data与业务请求一同上传，由后端请求AnalyzeNvc接口并返回100或者900。
    },

    // 业务键字段，可为空。该参数可用于上线前测试，请按照代码集成后测试部分中的方法配置该字段值。
    trans: { key1: 'code0', nvcCode: 400 },

    // 二次验证组件的语言，默认为cn（简体中文）。详细配置方法请参见自定义文案文档。
    language: 'cn',

    // 当唤醒滑动验证作为二次验证时，配置滑动验证组件的宽度。
    customWidth: 300,

    // 当唤醒刮刮卡验证作为二次验证时，配置刮刮卡组件的宽度。
    width: 300,

    // 当唤醒刮刮卡验证作为二次验证时，配置刮刮卡组件的高度。
    height: 100,

    // 当唤醒刮刮卡验证作为二次验证时，配置需要刮出的两个elements的图片资源。
    elements: ['//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png', '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png'],

    // 当唤醒刮刮卡验证作为二次验证时，配置刮动时的背景图像（自动应用平铺填充的方式）。
    bg_back_prepared: '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',

    // 当唤醒刮刮卡验证作为二次验证时，配置刮动时的前景图像（仅支持base64数据流）。
    bg_front:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',

    // 当唤醒刮刮卡验证作为二次验证时，配置验证通过时显示的图标资源。
    obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',

    // 当唤醒刮刮卡验证作为二次验证时，配置验证通过时显示的背景图像（自动应用平铺填充的方式）。
    bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',

    // 当唤醒刮刮卡验证作为二次验证时，配置验证失败或异常时显示的图标资源。
    obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',

    // 当唤醒刮刮卡验证作为二次验证时，配置验证失败或异常时显示的背景图像（自动应用平铺填充的方式）。
    bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',

    // 当唤醒刮刮卡验证作为二次验证时，用于自定义文案。详细配置方法请参见自定义文案文档。
    upLang: {
      cn: {
        _ggk_guide: '请摁住鼠标左键，刮出两面盾牌',
        _ggk_success: '恭喜您成功刮出盾牌<br/>继续下一步操作吧',
        _ggk_loading: '加载中',
        _ggk_fail: [
          '呀，盾牌不见了<br/>请',
          'javascript:noCaptcha.reset()',
          '再来一次',
          '或',
          'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN',
          '反馈问题',
        ],
        _ggk_action_timeout: [
          '我等得太久啦<br/>请',
          'javascript:noCaptcha.reset()',
          '再来一次',
          '或',
          'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN',
          '反馈问题',
        ],
        _ggk_net_err: [
          '网络实在不给力<br/>请',
          'javascript:noCaptcha.reset()',
          '再来一次',
          '或',
          'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN',
          '反馈问题',
        ],
        _ggk_too_fast: [
          '您刮得太快啦<br/>请',
          'javascript:noCaptcha.reset()',
          '再来一次',
          '或',
          'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN',
          '反馈问题',
        ],
      },
    },
  }
}

function wait(time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(true), time)
  })
}
async function injectDependencies() {
  const result1 = await injectScript('https://g.alicdn.com/sd/nvc/1.1.112/guide.js')
  const result2 = isH5
    ? await injectScript('https://g.alicdn.com/sd/nch5/index.js')
    : await injectScript('https://g.alicdn.com/sd/ncpc/nc.js')
  initSuccess = result1 && result2
  await wait(1000)

  return initSuccess
}

function injectScript(url) {
  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script')

      const today = new Date()
      const year = today.getFullYear()
      let month = today.getMonth() + 1
      if (month < 10) {
        month = `0${month}`
      }
      let date = today.getDate()
      if (date < 10) {
        date = `0${date}`
      }
      const todayStr = `${year}${month}${date}`

      script.src = `${url}?t=${todayStr}`

      const point = document.getElementById('app')
      point.parentNode.insertBefore(script, point)
      script.addEventListener('load', () => resolve(true))
    } catch (e) {
      reject(false)
    }
  })
}

export default {
  methods: {
    async initHumanCheckScripts() {
      let retryCount = 0
      while (!initSuccess && retryCount < 3) {
        try {
          initCfg()
          await injectDependencies()
        } catch (e) {
          console.error(e)
        }
        retryCount++
      }
      if (!initSuccess) {
        return alert('人机校验初始化失败')
      }

      return true
    },
    async invokeManMachineVerification({ onSuccess, failCb, slideEleId, onSlideFinish, beforeSliderShow }) {
      const success = await this.initHumanCheckScripts()
      if (!success) return

      try {
        const json = await this.$axios({
          baseURL: globalConfig.webServer,
          url: 'sender/robotAuth/apply/v3',
          method: 'post',
          data: {
            data: window.getNVCVal(),
          },
        })

        // const code = 400
        // testHM 给qa测试用
        const code = window.testHM ? 400 : +json.data.result

        if (code === 400) {
          beforeSliderShow && beforeSliderShow()

          // 唤醒滑动验证
          this.initSlide(slideEleId, onSlideFinish)
        } else if (code === 600) {
          // 唤醒刮刮卡
          window.getSC()
        } else if (code === 700) {
          // 唤醒问答验证码。由于问答验证码组件升级中，服务端暂时不会返回code为700的结果。您可以保留该部分的接入代码。
          window.getLC()
        } else if (code === 100 || code === 200) {
          // 注册成功
          // this.initSlide(slideEleId, onSlideFinish);
          window.nvcReset()
          onSuccess && onSuccess()
        } else if (code === 800 || code === 900) {
          // 直接拦截
          window.nvcReset()
          failCb && failCb(json)
        }
      } catch (e) {
        console.error(e)
        failCb && failCb()
      }
    },
    initSlide(eleId, onSlideFinish) {
      const { appkey } = window.NVC_Opt
      const opt = {
        appkey,
        eleId,
        onSlideFinish,
        token: [appkey, new Date().getTime(), Math.random()].join(':'),
      }

      if (isH5) {
        this.initH5SlideConfig(opt)
      } else {
        this.initWebSlideConfig(opt)
      }
    },
    initWebSlideConfig(opt) {
      const NoCaptcha = window.noCaptcha
      const nc = new NoCaptcha({
        ...this.getBaseSlideConfig(opt),
        times: 5,

        // 滑动条的宽度。
        customWidth: 300,

        // 是否启用。一般情况，保持默认值（true）即可。
        isEnabled: true,
      })

      // 用于自定义文案。详细配置方法请参见自定义文案与多语言文档。
      nc.upLang('cn', {
        _startTEXT: '请按住滑块，拖动到最右边',
        _yesTEXT: '验证通过',
        _error300: '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>',
      })
    },
    initH5SlideConfig(opt) {
      const nc = window.NoCaptcha.init({
        ...this.getBaseSlideConfig(opt),
        retryTimes: 5,

        // 验证通过后，验证码组件是否自动隐藏，默认不隐藏（false）。
        bannerHidden: false,

        // 是否默认不渲染，默认值false。当设置为true时，不自动渲染，需要自行调用show方法进行渲染。
        initHidden: false,
      })
      window.NoCaptcha.setEnabled(true)
      nc.reset()
      window.NoCaptcha.upLang('cn', {
        // 加载状态提示。
        LOADING: '加载中...',

        // 等待滑动状态提示。
        SLIDER_LABEL: '请向右滑动验证',

        // 验证通过状态提示。
        CHECK_Y: '验证通过',

        // 验证失败触发拦截状态提示。
      })
    },
    getBaseSlideConfig({ appkey, eleId, token, onSlideFinish }) {
      const scene = isH5 ? 'nc_login_h5' : 'nc_login'

      return {
        // 声明滑动验证需要渲染的目标元素ID。
        renderTo: eleId,

        // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
        appkey,

        // 使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
        scene,

        // 滑动验证码的主键，请勿将该字段定义为固定值。确保每个用户每次打开页面时，其token值都是不同的。系统默认的格式为：”您的appkey”+”时间戳”+”随机数”。
        token,

        // 业务键字段，可为空。为便于线上问题的排查，建议您按照线上问题定位文档中推荐的方法配置该字段值。
        trans: { key1: 'code0' },

        // 通过Dom的ID属性自动填写trans业务键，可为空。建议您按照线上问题定位文档中推荐的方法配置该字段值。
        elementID: ['usernameID'],

        // 是否自定义配置底层采集组件。如无特殊场景，请使用默认值（0），即不自定义配置底层采集组件。
        // eslint-disable-next-line camelcase
        is_Opt: 0,

        // 语言。PC端Web页面场景默认支持18国语言，详细配置方法请参见自定义文案与多语言文档。
        language: 'cn',

        // 内部网络请求的超时时间。一般情况建议保持默认值（3000ms）。
        timeout: isH5 ? 10000 : 3000,

        // 用于自定义滑动验证各项请求的接口地址。一般情况，请勿配置该参数。
        apimap: {
          // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
          // 'get_captcha': '//b.com/get_captcha/ver3',
          // 'get_captcha': '//pin3.aliyun.com/get_captcha/ver3'
          // 'get_img': '//c.com/get_img',
          // 'checkcode': '//d.com/captcha/checkcode.jsonp',
          // 'umid_Url': '//e.com/security/umscript/3.2.1/um.js',
          // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
          // 'umid_serUrl': 'https://g.com/service/um.json'
        },

        // 前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
        callback(data) {
          onSlideFinish &&
            onSlideFinish({
              scene,
              token,
              sessionId: data.csessionid,
              sig: data.sig,
            })
        },
      }
    },
  },
}
